export default "__VITE_ASSET__CRDiNLQu__"